// src/components/VideoTab.jsx
import React, { useState } from "react";
import VideoControls from "./VideoControls";
import VideoStream from "./VideoStream";
import { apiService } from "../services/apiService";

const VideoTab = ({
  addNotification,
  setIsDetecting,
  setStatus,
  setDetections,
  setSummary,
  isDetecting,
  status,
}) => {
  const [streamUrl, setStreamUrl] = useState(
    "rtsp://113.161.109.237:8554/sample01"
  );
  const [confidence, setConfidence] = useState(0.7);
  const [riskThreshold, setRiskThreshold] = useState(0.8);
  const [loading, setLoading] = useState(false);

  const handleTestSource = async () => {
    if (!streamUrl.trim()) {
      addNotification("Please enter a video source", "warning");
      return;
    }

    addNotification("Testing video source...", "info");

    try {
      const result = await apiService.testVideoSource(streamUrl);

      if (result.success) {
        const props = result.properties;
        addNotification(
          `✅ ${result.source_type} is working! ${props.width}x${props.height}`,
          "success"
        );
      } else {
        addNotification(`❌ Test failed: ${result.error}`, "error");
      }
    } catch (error) {
      addNotification(`Connection error: ${error.message}`, "error");
    }
  };

  const handleStartDetection = async () => {
    setLoading(true);

    try {
      const result = await apiService.startDetection(
        streamUrl,
        confidence,
        riskThreshold
      );

      if (result.success) {
        addNotification("Detection started successfully!", "success");
        setIsDetecting(true);
      } else {
        const errorMsg = result.error || "Failed to start detection";
        addNotification(errorMsg, "error");
      }
    } catch (error) {
      addNotification(`Network error: ${error.message}`, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleStopDetection = async () => {
    try {
      await apiService.stopDetection();
      addNotification("Detection stopped", "info");
      setIsDetecting(false);
      setStatus(null);
    } catch (error) {
      addNotification(`Error stopping detection: ${error.message}`, "error");
    }
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "30px",
        marginBottom: "30px",
      }}
    >
      <VideoControls
        streamUrl={streamUrl}
        setStreamUrl={setStreamUrl}
        confidence={confidence}
        setConfidence={setConfidence}
        riskThreshold={riskThreshold}
        setRiskThreshold={setRiskThreshold}
        onTest={handleTestSource}
        onStart={handleStartDetection}
        onStop={handleStopDetection}
        isDetecting={isDetecting}
        loading={loading}
      />

      <VideoStream isDetecting={isDetecting} status={status} />
    </div>
  );
};

export default VideoTab;
